import { Container, Typography } from "@mui/material";
import Image from "next/image";
import React, { useContext } from "react";
import { LocalizationContext } from "../../lib/context";
import { keyBy, merge, values } from "lodash";

const skillData = [
  {
    skillId: "creative",
    icon: "/assets/creative.svg",
  },
  {
    skillId: "survey and mapping",
    icon: "/assets/survey_mapping.svg",
  },
  {
    skillId: "agricultural",
    icon: "/assets/agricultural.svg",
  },
  {
    skillId: "service",
    icon: "/assets/service.svg",
  },
  {
    skillId: "education",
    icon: "/assets/education.svg",
  },
  {
    skillId: "FPV",
    icon: "/assets/ar.svg",
  },
];

const InspirationsInfoSection = () => {
  const { inspirationsPage, uiGeneral } =
    useContext(LocalizationContext).localeStrings;
  const localizedSkills = uiGeneral.skills.filter((s) => s.skillId !== "other");
  const mergedSkills = values(
    merge(keyBy(localizedSkills, "skillId"), keyBy(skillData, "skillId"))
  );

  return (
    <div className="inspire__info">
      <Container className="inspire__info--content">
        <div>
          <Typography
            color="primary.light"
            fontWeight="600"
            sx={{ fontSize: 24 }}
            mb={2}
            children={inspirationsPage.pageTitle}
          />

          <Typography
            color="primary.light"
            fontWeight="700"
            variant="h2"
            sx={{ fontSize: 30 }}
            m={0}
            children={inspirationsPage.subtitle1}
          />
          <Typography
            color="primary.light"
            fontWeight="700"
            variant="h2"
            sx={{ fontSize: 30 }}
            m={0}
            children={inspirationsPage.subtitle2}
          />
        </div>

        <div className="inspire__info--items">
          {mergedSkills.map((item) => (
            <div className="inspire__info--item" key={item.skillId}>
              <div className="inspire__info--item-header">
                <Image
                  src={item.icon}
                  alt="color-palette"
                  width="32"
                  height="32"
                />
                <Typography variant="h2" color="white">
                  {item.name}
                </Typography>
              </div>

              <Typography
                color="white"
                variant="subtitle1"
                className="inspire__info--item-text"
                children={item.description}
              />
            </div>
          ))}
        </div>

        <div className="inspire__info--bottom">
          <Image
            src="/assets/arrow-down-white.svg"
            alt="color-palette"
            width="20"
            height="20"
            onClick={() => window.scrollTo({ top: 1100, behavior: "smooth" })}
          />
        </div>
      </Container>
    </div>
  );
};

export default InspirationsInfoSection;
